import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useNavigate, useParams } from "react-router-dom";
import ag1 from "../../../assets/ag1.png";
import email from "../../../assets/message_icon.png";
import mailWhite from "../../../assets/mailWhite.png";
import call from "../../../assets/call_icon.png";
import shareRed from "../../../assets/shareRed.png";
import a2 from "../../../assets/a2.png";
import facebbok from "../../../assets/facebbok.png";
import twitter from "../../../assets/twitter.png";
import linkedIn from "../../../assets/linkedIn.png";
import { BACKEND_BASE_URL } from "../../../apiInstances/baseurl";
import Review from "../Review/Review";
import isEmpty from "../utils/isEmpty";
import whatsapp from "../../../assets/whatsapp.png";
import { TfiEmail } from "react-icons/tfi";
import { IoIosLink } from "react-icons/io";
import { toast } from "react-toastify";
import GeneralEnquiry from "../GeneralEnquiry/GeneralEnquiry";
import { FaStar } from "react-icons/fa";
import { MdIosShare } from "react-icons/md";
import { MessageCircle, Phone } from "lucide-react";

const AgentConnectCard = ({
  AgentData,
  averageRatings,
  scrollToDiv,
  isDesktop = true,
  isMobile = false,
}) => {
  //console.log("🚀 ~ AgentConnectCard ~ AgentData:", AgentData);
  //console.log("🚀 ~ Aurl:", AgentData?.linkedIn_profile_URL);

  const { id } = useParams();
  const [share, setShare] = useState(false);
  const [calls, setCalls] = useState(false);
  const navigate = useNavigate();
  const copyEmail = (data) => {
    if (data === "email") {
      navigator.clipboard.writeText(AgentData?.confirm_email);
      toast.success("email copy successfully");
    } else {
      navigator.clipboard.writeText(
        `https://www.myrealestate-ng.com/agent-profile/${id}`,
      );
      toast.success("link copy successfully");
    }
  };

  return (
    <>
      {isDesktop && (
        <div className="w-[294px] rounded-2xl shadow-[0_10px_25px_rgba(15,23,42,0.18)] overflow-hidden bg-white">
          {/* Top brand bar */}
          <div
            onClick={() => navigate(`/agency-profile/${AgentData?.agency_id?._id}`)}
            className={`h-[76px] flex items-center cursor-pointer justify-center ${AgentData?.agency_id?.primary_color ? "" : "bg-black"}`}
            style={
              AgentData?.agency_id?.primary_color
                ? { backgroundColor: AgentData.agency_id.primary_color }
                : undefined
            }
          >
            <img
              src={AgentData?.agency_id?.agencyLargeLogo}
              alt="agency logo"
              className="h-8 object-contain"
            />
            <span className="text-white text-base tracking-[0.3em] uppercase">
              {AgentData?.agency_id?.agency_name}
            </span>
          </div>

          {/* Profile and content */}
          <div className="px-6 py-6 flex flex-col items-center">
            <div className="relative">
              <img
                src={AgentData?.profileImg || ag1}
                alt="profile"
                className="w-[120px] h-[120px] rounded-full border-[4px] border-[#E9E9E9] object-cover"
              />

              {/* Verified Badge */}
              <div className="absolute bottom-0 right-0 bg-[#2563EB] w-7 h-7 rounded-full flex items-center justify-center border-[3px] border-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3.5 h-3.5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={3}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            {/* Name */}
            <h3 className="mt-4 text-[20px] font-semibold text-[#111827]">
              {AgentData?.first_name} {AgentData?.last_name}
            </h3>

            {/* Rating */}
            <div className="flex flex-col items-center mt-2">
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <FaStar key={star} className="text-[#FACC15] text-lg" />
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-1">
                {AgentData?.reviews?.length || 0} reviews
              </p>
            </div>

            {/* Primary Button */}
            <button
              onClick={() => navigate(`/appraisal/${AgentData?._id}`)}
              className="mt-5 w-full bg-[#097FE6] hover:bg-[#097FE6] text-white py-3 rounded-full font-semibold transition"
            >
              Request a free appraisal
            </button>

            {/* Secondary Buttons */}
            <a
              href={`tel:${AgentData?.mobile_number}`}
              rel="noopener noreferrer"
              className="mt-3 w-full border border-[#E5E7EB] py-3 rounded-full font-semibold flex items-center justify-center gap-2 text-[#111827] hover:bg-[#F9FAFB] transition"
            >
              <Phone size={16} />
              <span>Call</span>
            </a>

            <a
              href={`https://wa.me/${AgentData?.mobile_number}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 w-full border border-[#E5E7EB] py-3 rounded-full font-semibold flex items-center justify-center gap-2 text-[#111827] hover:bg-[#F9FAFB] transition"
            >
              <MessageCircle size={18} strokeWidth={2.5} />
              <span>Whatsapp</span>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default AgentConnectCard;
